import React, {Fragment, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import * as actions from '../favouritesActions';
import FavouriteIcon from './components/FavouriteIcon';
import Alert from '../../Alert/Alert';
import {createAlert} from '../../Alert/alertActions';
import {isArray} from 'lodash';

const FavouriteIconContainer = ({
  flatProduct,
  addToFavourites,
  shouldAlignCenter,
  deleteFavourite,
  isFavourited,
  favouriteId,
  selectedFavouriteId,
  clearSelectedFavouriteId,
  addedToFavourites,
  isAuthenticated,
  createAlert,
}) => {
  const [productIsFavourite, setProductIsFavourite] = useState(
    isFavourited || false
  );

  const [productJustFavourited, setProductJustFavourited] = useState(false);

  const [productFavouriteId, setProductFavouriteId] = useState(
    favouriteId || null
  );

  useEffect(() => {
    setProductFavouriteId(favouriteId);
    setProductIsFavourite(favouriteId ? true : false);
  }, [favouriteId]);

  useEffect(() => {
    if (productJustFavourited && selectedFavouriteId) {
      setProductFavouriteId(selectedFavouriteId);
      clearSelectedFavouriteId();
      setProductJustFavourited(false);
      if (addedToFavourites) addedToFavourites(selectedFavouriteId);
    }
  }, [productJustFavourited, selectedFavouriteId]);

  const handleAddToFavourites = () => {
    addToFavourites(flatProduct, flatProduct.name);
    setProductJustFavourited(true);
    setProductIsFavourite(true);
    createAlert({
      type: 'success',
      message: `${flatProduct.name} was succesfully added to the favourites list`,
    });
  };

  const removeFavourite = () => {
    deleteFavourite(productFavouriteId);
    setProductFavouriteId(null);
    setProductIsFavourite(false);
    createAlert({
      type: 'success',
      message: `${flatProduct.name} was succesfully removed from your favourites list`,
    });
  };

  return (
    <Fragment>
      <Alert />
      {isAuthenticated ? (
        <FavouriteIcon
          id="Favourites-FavouriteIcon"
          shouldAlignCenter={shouldAlignCenter}
          productIsFavourite={productIsFavourite}
          disabled={productJustFavourited}
          onClick={() => {
            if (productIsFavourite) removeFavourite();
            else handleAddToFavourites();
          }}
        />
      ) : (
        <div />
      )}
    </Fragment>
  );
};

const mapStateToProps = state => ({
  selectedFavouriteId: state.favouritesReducer.selectedFavouriteId,
  isAuthenticated: state.authReducer.isAuthenticated,
});

export default connect(mapStateToProps, {...actions, createAlert})(
  FavouriteIconContainer
);
